import React, { Fragment } from 'react'
import { Input } from 'loyal-react'
import PropTypes from 'prop-types'

const DefaultTemplate = props => {
  return (
    <Fragment>
      <Input
        id={props.name}
        name={props.name}
        label={props.labelDescription}
        className='col-12'
        iconName='icon_calendar cursor'
        iconOnClick={() => props.onClick}
        value={props.value}
      />
    </Fragment>
  )
}

DefaultTemplate.propTypes = {
  name: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.string,
  labelDescription: PropTypes.string
}

export default DefaultTemplate



// WEBPACK FOOTER //
// ./src/features/DatePicker/DefaultTemplate.js